module.exports = __webpack_public_path__ + "img/footer.ec7bc8ea.png";